"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _field = require("./field");
var _label = _interopRequireDefault(require("./label"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _fieldsize = require("./fieldsize");
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _autocompleteModule = _interopRequireDefault(require("./autocomplete.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const getSuggestionLabel = suggestion => suggestion.label;
const createRenderInputComponent = showClearButton => function Input(inputProps) {
  // See: https://stackoverflow.com/questions/61785523/autosuggest-renderinputcomponent-inputprops-types-of-property-onchange-are-i
  const onChangeHandler = event => {
    inputProps.onChange(event, {
      newValue: event.target.value,
      method: 'type'
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, inputProps, {
    onChange: onChangeHandler
  })), showClearButton && inputProps.value ? /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Clear search text",
    className: _autocompleteModule.default.clearButton,
    type: "button"
    // we use onPointerDown instead of onClick to prevent the textfield from losing focus
    ,

    onPointerDown: e => {
      e.preventDefault();
      inputProps.onChange(e, {
        newValue: '',
        method: 'type'
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "clear",
    size: "small",
    className: _autocompleteModule.default.clearIcon
  })) : null);
};
const renderSuggestion = (suggestion, params) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)(_autocompleteModule.default.AutocompleteItem, {
    [_autocompleteModule.default.highlightedItem]: params.isHighlighted
  })
}, suggestion.label);
const renderSuggestionContainer = (containerProps, children, inputRef, value, suggestions, filteredSuggestions, noMatchLabel, shouldRenderSuggestions, suggestionsFooterImage, suggestionsFooterImageAlt, renderSuggestionsInline) => {
  // Do not render the container if suggestions should not be rendered
  if (shouldRenderSuggestions && !shouldRenderSuggestions(value)) {
    return undefined;
  }
  if (value && filteredSuggestions.length === 0 && suggestions.findIndex(suggestion => suggestion.label === value) < 0 &&
  // Do not render the no matches container if the input is out of focus
  document.activeElement === inputRef.current) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, containerProps, {
      className: (0, _classnames.default)(_autocompleteModule.default.AutocompleteMenu, {
        [_autocompleteModule.default.AutoCompleteMenuInline]: renderSuggestionsInline
      }, _autocompleteModule.default.disabled, _autocompleteModule.default.AutocompleteItem)
    }), noMatchLabel);
  }
  return children ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, containerProps, {
    className: (0, _classnames.default)(_autocompleteModule.default.AutocompleteMenu, {
      [_autocompleteModule.default.AutoCompleteMenuInline]: renderSuggestionsInline
    })
  }), children, suggestionsFooterImage && /*#__PURE__*/_react.default.createElement("div", {
    className: _autocompleteModule.default.SuggestionsFooter
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: suggestionsFooterImage,
    alt: suggestionsFooterImageAlt,
    className: _autocompleteModule.default.SuggestionsFooterImage
  }))) : undefined;
};
const filterSuggestions = (value, suggestions) => [...suggestions.filter(suggestion => suggestion.label.toLowerCase().includes(value.trim().toLowerCase()))];
const AutoComplete = props => {
  var _props$onSuggestionsF;
  const {
    shouldRenderSuggestions,
    placeholder,
    errorMessage,
    ariaLabel,
    name,
    label,
    classNames,
    type,
    size,
    noMatchLabel = 'No matches found',
    hideArrow,
    showClearButton = false,
    onBlur,
    onSelect,
    onKeyPress
  } = props;
  const inputRef = (0, _react.useRef)(null);
  const [value, setValue] = (0, _react.useState)(props.value.toString());
  const [suggestions, setSuggestions] = (0, _react.useState)([]);
  const [hasNotHighlighted, setHasNotHighlighted] = (0, _react.useState)(true);
  const onSuggestionsFetchRequested = (_props$onSuggestionsF = props.onSuggestionsFetchRequested) !== null && _props$onSuggestionsF !== void 0 ? _props$onSuggestionsF : _ref => {
    let {
      value
    } = _ref;
    setSuggestions(filterSuggestions(value, props.options));
  };
  const onSuggestionsClearRequested = () => {
    // Do not reset internal state if suggestions are managed outside of the component
    if (!props.onSuggestionsFetchRequested) {
      setSuggestions([]);
    }
  };
  const onSuggestionHighlighted = _ref2 => {
    let {
      suggestion
    } = _ref2;
    setHasNotHighlighted(suggestion === null);
  };
  const onChange = (_event, _ref3) => {
    let {
      newValue
    } = _ref3;
    // Note: Unfortunately the event returned by react-autosuggest is not always the event from the input changing,
    // when an option is selected react-autosuggest returns the event corresponding to the div clicked instead
    // That is the reason why we decided to pass the new value of the input (string) instead of the event
    props.onChange(newValue);
    setValue(newValue);
  };
  (0, _react.useEffect)(() => {
    setValue(props.value.toString());
    setSuggestions(props.options);
  }, [props.value, props.options]);
  const id = props.id || (0, _field.makeIdString)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_autocompleteModule.default.Wrapper, _textfieldModule.default.Textfield, classNames === null || classNames === void 0 ? void 0 : classNames.wrapper)
  }, label && /*#__PURE__*/_react.default.createElement(_label.default, {
    className: (0, _classnames.default)(classNames === null || classNames === void 0 ? void 0 : classNames.label, {
      [_textfieldModule.default.errorLabel]: errorMessage
    }),
    for: id,
    size: size
  }, label), /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, {
    inputProps: {
      value,
      type,
      placeholder,
      'aria-label': ariaLabel,
      id,
      name,
      onChange,
      onBlur,
      ref: inputRef,
      onKeyPress
    },
    highlightFirstSuggestion: hasNotHighlighted,
    suggestions: suggestions,
    getSuggestionValue: getSuggestionLabel,
    renderSuggestion: renderSuggestion,
    renderInputComponent: createRenderInputComponent(showClearButton),
    renderSuggestionsContainer: _ref4 => {
      let {
        containerProps,
        children
      } = _ref4;
      return renderSuggestionContainer(containerProps, children, inputRef, value, props.options, suggestions, noMatchLabel, shouldRenderSuggestions, props.suggestionsFooterImage, props.suggestionsFooterImageAlt, props.renderSuggestionsInline);
    },
    shouldRenderSuggestions: shouldRenderSuggestions !== null && shouldRenderSuggestions !== void 0 ? shouldRenderSuggestions : () => true,
    theme: {
      container: (0, _classnames.default)(_autocompleteModule.default.AutocompleteWrapper, _textfieldModule.default.fieldIconContainer, {
        [_autocompleteModule.default.AutocompleteWrapperCarrot]: !hideArrow
      }),
      suggestionsContainerOpen: _autocompleteModule.default.AutocompleteMenu,
      input: (0, _classnames.default)(_textfieldModule.default.field, {
        [_textfieldModule.default.field]: size === _fieldsize.FieldSize.DEFAULT,
        [_textfieldModule.default.fieldSmall]: size === _fieldsize.FieldSize.SMALL,
        [_textfieldModule.default.fieldInvalid]: errorMessage
      }, classNames === null || classNames === void 0 ? void 0 : classNames.field, {
        [_autocompleteModule.default.fieldWithClearButton]: showClearButton && value
      })
    },
    onSuggestionSelected: onSelect ? (_event, data) => onSelect(data.suggestion) : undefined,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    onSuggestionHighlighted: onSuggestionHighlighted
  }), errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
    message: errorMessage,
    className: classNames === null || classNames === void 0 ? void 0 : classNames.errorMessage,
    size: _fieldsize.FieldSize.SMALL
  }));
};
var _default = exports.default = AutoComplete;